import { Input } from "antd";
import type { TextAreaProps } from "antd/es/input";
import styles from "./index.module.css";

const { TextArea } = Input;

type Props = TextAreaProps & { isMessage?: boolean };

export const CustomTextArea = (props: Props) => {
  return (
    <TextArea
      {...props}
      autoSize={props.isMessage ? { minRows: 1, maxRows: 4 } : undefined}
      className={`${styles.textArea} ${props.isMessage ? styles.messageTextArea : ""}`}
    />
  );
};
